import { jsx as _jsx } from "react/jsx-runtime";
import { Box, debounce } from "@mui/material";
import { useLayoutEffect, useState } from "react";
import { getRecipeTypeChipsToRender } from "../utils/getRecipeTypeChipsToRender";
import { ItemChip } from "./ItemChip";
export const RecipeTypeChips = ({ recipeTypeChips, handleClick, setDialogContentMode, setIsDetailDialogOpen, isDetailDialogOpen, }) => {
    const [maxChipsCalculated, setMaxChipsCalculated] = useState(3);
    const recipeTypeChipsToRender = getRecipeTypeChipsToRender(recipeTypeChips, maxChipsCalculated);
    useLayoutEffect(() => {
        let isMounted = true;
        const recipeChipsWraps = document.querySelectorAll(".recipe-chips");
        const handleResize = debounce((entries) => {
            try {
                if (isMounted) {
                    entries.forEach((entry) => {
                        const { width } = entry.contentRect;
                        setMaxChipsCalculated(Math.floor(width / 70));
                    });
                }
            }
            catch (error) {
                console.error("Error in Recipe Type Chip ResizeObserver callback:", error);
            }
        }, 50);
        const recipeChipsWrapObserver = new ResizeObserver(handleResize);
        recipeChipsWraps.forEach((chipsWrap) => {
            recipeChipsWrapObserver.observe(chipsWrap);
        });
        return () => {
            isMounted = false;
            recipeChipsWrapObserver.disconnect();
        };
    }, []);
    return (_jsx(Box, Object.assign({ display: "flex", justifyContent: "flex-start", flexWrap: "wrap", width: "100%", maxHeight: "1.5rem", overflow: "hidden", className: "recipe-chips" }, { children: recipeTypeChipsToRender.map((rt) => (_jsx(ItemChip, { sx: rt.clickable ? { "& .MuiChip-label": { textDecoration: "underline" } } : undefined, label: rt.label, clickable: rt.clickable, onClick: rt.clickable ? handleClick(setDialogContentMode, setIsDetailDialogOpen, isDetailDialogOpen) : undefined }, rt.label))) })));
};
